// Popover scroll management
function managePopoverScroll() {
  const popovers = document.querySelectorAll('[popover]');

  /**
   * Locks or unlocks page scroll based on open popovers.
   */
  const syncScrollLock = () => {
    const hasOpenPopover = [...popovers].some((popover) => {
      if (typeof popover.matches === 'function' && popover.matches(':popover-open')) {
        return true;
      }

      return (
        popover.classList.contains('mini-cart-wrapper--fallback-open') ||
        popover.classList.contains('mobile-nav-component--fallback-open') ||
        popover.classList.contains('mobile-search-popover--fallback-open')
      );
    });

    document.documentElement.classList.toggle('noScroll', hasOpenPopover);
    document.body.classList.toggle('noScroll', hasOpenPopover);
  };

  popovers.forEach(popover => {
    // Listen for popover state changes
    popover.addEventListener('toggle', () => {
      requestAnimationFrame(syncScrollLock);
    });
  });
}

function formatMoney(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.', ''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || "${{amount}}");

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};



function cartQuantity() {
  const quantitySelectors = document.querySelectorAll('.js-cart-item-quantity');

  quantitySelectors.forEach(selector => {
    if (selector.dataset.qtyBound === 'true') {
      return;
    }

    const minusBtn = selector.querySelector('.js-cart-item-decrease');
    const plusBtn = selector.querySelector('.js-cart-item-increase');
    const quantityInput = selector.querySelector('.quantity-value');

    if (minusBtn && plusBtn && quantityInput) {
      let currentQuantity = parseInt(quantityInput.value) || 1;
      const maxQuantity = parseInt(quantityInput.getAttribute('max')) || Infinity;

      // Update quantity display
      function updateQuantity() {
        quantityInput.value = currentQuantity;

        // Disable minus button if quantity is 1
        minusBtn.disabled = currentQuantity <= 1;

        // Disable plus button if quantity is at max
        plusBtn.disabled = currentQuantity >= maxQuantity;

        // Trigger change event to notify Cart class
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // Minus button click handler
      minusBtn.addEventListener('click', function () {
        if (currentQuantity > 1) {
          currentQuantity--;
          updateQuantity();
        }
      });

      // Plus button click handler
      plusBtn.addEventListener('click', function () {
        if (currentQuantity < maxQuantity) {
          currentQuantity++;
          updateQuantity();
        }
      });

      minusBtn.disabled = currentQuantity <= 1;
      plusBtn.disabled = currentQuantity >= maxQuantity;
      selector.dataset.qtyBound = 'true';
    }
  });
}

managePopoverScroll();
cartQuantity();

// A cart write shows the overlay loading wheel only once it has run this
// long. Ticking an extra spins a small wheel on that row at once and shows
// the new total straight away, so the overlay waits for a real stall.
const ADDON_SPINNER_DELAY = 1200;
const ADDON_SPINNER_DELAY_INSTANT = 3000;
// sessionStorage flag: a cart save was still running when the page closed
const SAVE_IN_FLIGHT_KEY = 'comfyCartSaving';

cartFunction = function () {
  if (window.__comfybedssCart) {
    return window.__comfybedssCart;
  }

  class Cart {
    triggers = {
      "click": {
        '[data-cart-remove]': 'handleRemove',
        '[data-cart-add]': 'handleAdd',
      },
      "change": {
        '[data-cart-quantity]': 'handleQuantity',
        '[data-cart-addon-checkbox]': 'handleAddonToggle',
      }
    };

    _atcAnimTimers = new WeakMap();
    _atcAnimDurationMs = 2000;
    _staleAddonCleanupRunning = false;

    // Drawer writes: the last known cart, the write queue, and quantity taps
    // still settling. See queueCartWrite.
    _cart = null;
    _cartQueue = Promise.resolve();
    _writesQueued = 0;
    _qtyTimers = new Map();
    _latestSections = null;
    _batchCartFresh = false;
    _batchNeedsRefresh = false;
    _writeTokens = new Map();
    _addonLoading = false;
    _addonBlocking = false;
    _addonLoadingTimers = [];
    // Writes queued that are not quiet extras writes (see queueCartWrite)
    _loudWrites = 0;
    // Totals painted ahead of the save, so quick taps can build on them
    _estimatedTotals = null;
    // Basket page list must be redrawn after its queued writes land
    _pageNeedsRepaint = false;

    constructor() {
      this._cart = this.readEmbeddedCart(document);
      this.initHandlers();
      this.afterCartMarkupReady(null);
      this.checkUnfinishedSave();
    }

    /**
     * A save still in flight when the customer reloaded or moved on can land
     * after the next page was drawn, leaving it showing (and building its
     * next write from) the cart from before. Only then, check the live cart
     * and redraw if it moved; ordinary page loads cost no request.
     */
    checkUnfinishedSave() {
      let unfinished = false;
      try {
        unfinished = sessionStorage.getItem(SAVE_IN_FLIGHT_KEY) === '1';
        sessionStorage.removeItem(SAVE_IN_FLIGHT_KEY);
      } catch (error) {
        return;
      }
      if (!unfinished) return;

      const signature = (cart) =>
        cart ? cart.items.map((item) => `${item.key}:${item.quantity}`).join('|') + `|${cart.total_price}` : '';
      const drawn = signature(this.readEmbeddedCart(document));
      const busy = () => this._writesQueued > 0 || this._qtyTimers.size > 0;
      // Twice: the save may land just after the first look
      const check = (tries) =>
        this.fetchCartJson()
          .then((cart) => {
            if (busy()) return;
            if (signature(cart) === drawn) {
              if (tries > 1) setTimeout(() => check(tries - 1), 1500);
              return;
            }
            this._cart = cart;
            this.updateSummary(cart);
            return this.isCartPage() ? this.repaintCartPage() : this.refreshCart(null);
          })
          .catch((error) => console.error(error));
      check(2);
    }

    initHandlers() {
      for (const [event, trigger] of Object.entries(this.triggers)) {
        document.addEventListener(event, function (e) {
          for (const [key, value] of Object.entries(this.triggers[e.type])) {
            var target = e.target.closest(key)
            if (target) {
              this[value](e, target);
            }
          }
        }.bind(this))
      }
    }

    getCartButton() {
      const buttons = document.querySelectorAll('[data-cart-btn]');

      return [...buttons].find((btn) => btn.offsetParent !== null) || buttons[0] || null;
    }

    openSlideCart() {
      const cartWrapper = document.getElementById('mini-cart-wrapper');
      const cartBtn = this.getCartButton();

      if (!cartWrapper) {
        return;
      }

      const isNativePopover = typeof cartWrapper.showPopover === 'function';
      const isOpen = isNativePopover
        ? cartWrapper.matches(':popover-open')
        : cartWrapper.classList.contains('mini-cart-wrapper--fallback-open');

      if (isOpen) {
        return;
      }

      // Match legacy toggleCart('open'): cart button click is the most reliable opener.
      if (cartBtn && cartBtn.getAttribute('aria-expanded') !== 'true') {
        cartBtn.click();
        return;
      }

      if (isNativePopover) {
        try {
          cartWrapper.showPopover();
        } catch (error) {
          cartBtn?.click();
        }
      } else {
        cartWrapper.classList.add('mini-cart-wrapper--fallback-open');
        document.documentElement.classList.add('noScroll');
        document.body.classList.add('noScroll');
        cartWrapper.dispatchEvent(new Event('toggle'));
      }

      if (cartBtn) {
        cartBtn.setAttribute('aria-expanded', 'true');
      }
    }

    closeSlideCart() {
      const cartWrapper = document.getElementById('mini-cart-wrapper');
      const cartBtn = this.getCartButton();

      if (cartWrapper && typeof cartWrapper.hidePopover === 'function') {
        if (cartWrapper.matches(':popover-open')) {
          cartWrapper.hidePopover();
        }
      } else if (cartWrapper) {
        cartWrapper.classList.remove('mini-cart-wrapper--fallback-open');
        document.documentElement.classList.remove('noScroll');
        document.body.classList.remove('noScroll');
        cartWrapper.dispatchEvent(new Event('toggle'));
      }

      if (cartBtn) {
        cartBtn.setAttribute('aria-expanded', 'false');
      }
    }

    toggleCart(action) {
      if (action === 'open') {
        this.openSlideCart();
      } else if (action === 'close') {
        this.closeSlideCart();
      } else {
        const cartWrapper = document.getElementById('mini-cart-wrapper');
        const isNativePopover = cartWrapper && typeof cartWrapper.showPopover === 'function';
        const isOpen = isNativePopover
          ? cartWrapper.matches(':popover-open')
          : cartWrapper?.classList.contains('mini-cart-wrapper--fallback-open');

        if (isOpen) {
          this.closeSlideCart();
        } else {
          this.openSlideCart();
        }
      }

      let productQuickView = document.querySelector('.product-quick-view-dialog[open]');

      if (productQuickView) {
        setTimeout(() => {
          productQuickView.close();
        }, 300);
      }
    };

    startLoading() {
      const target = document.querySelectorAll(
        '[data-cart-contents], [data-cart-page-contents]'
      );
      target.forEach(el => {
        el.style.pointerEvents = 'none';
        el.style.opacity = 0.5;
      });
    }

    endLoading() {
      const target = document.querySelectorAll(
        '[data-cart-contents], [data-cart-page-contents]'
      );
      target.forEach(el => {
        el.style.pointerEvents = 'auto';
        el.style.opacity = 1;
      });
    }

    updateSummary(data, action = null) {
      if (!data || typeof data.item_count !== 'number') {
        this.fetchCartJson()
          .then((cart) => this.updateSummary(cart, action))
          .catch((error) => console.error(error));
        return;
      }

      if (Array.isArray(data.items)) {
        this._cart = data;
      }

      if (data.total_discount > 0) {
        document.querySelectorAll('.js-cart-discount').forEach(row => {
          if (row.classList.contains('hidden')) {
            row.classList.remove('hidden');
          }
        });
      } else {
        document.querySelectorAll('.js-cart-discount').forEach(row => {
          if (!row.classList.contains('hidden')) {
            row.classList.add('hidden');
          }
        });
      }

      if (data.item_count > 0) {
        document.querySelectorAll('[data-cart-empty]').forEach(cartEmpty => cartEmpty.remove());
        document.querySelectorAll('[data-cart-hidden]').forEach(cartHidden => cartHidden.classList.remove('hidden'));
      } else {
        document.querySelectorAll(
          '[data-cart-contents], [data-cart-page-contents]'
        ).forEach(cartContents => {
          if (!cartContents.querySelector('[data-cart-empty]')) {
            // The drawer and basket page share a designed empty state (snippets/mini-cart-empty.liquid)
            const emptyTemplate = cartContents
              .closest('.mini-cart-wrapper, .cart-wrapper')
              ?.querySelector('template[data-cart-empty-template]');
            if (emptyTemplate) {
              cartContents.prepend(emptyTemplate.content.cloneNode(true));
            } else {
              cartContents.insertAdjacentHTML("afterbegin", '<p class="block text-center text-sm" data-cart-empty>' + window.cartLang.emptyCart + '</p>');
            }
          }
        });
        document.querySelectorAll('[data-cart-hidden]').forEach(cartHidden => cartHidden.classList.add('hidden'));
      }

      const visibleItemCount = this.getVisibleItemCount(data);

      let cartKeyData = {
        '[data-cart-item-count]': visibleItemCount,
        '[data-cart-subtotal]': formatMoney(data.original_total_price, window.theme.moneyFormat),
        '[data-cart-items-subtotal]': formatMoney(data.items_subtotal_price, window.theme.moneyFormat),
        // Liquid renders the discount with a leading minus; keep it on refresh
        '[data-cart-discount]': '-' + formatMoney(data.total_discount, window.theme.moneyFormat),
        '[data-cart-total]': data.total_price,
      };
      for (const [key, value] of Object.entries(cartKeyData)) {
        document.querySelectorAll(key).forEach(item => {
          if (item.hasAttribute("data-cart-total")) {
            item.setAttribute('data-cart-total', value)
            item.innerHTML = formatMoney(value, window.theme.moneyFormat)
          } else {
            item.innerHTML = value;
          }
        });
      }

      this.updateMiniCartTitle(visibleItemCount);

      if (document.body.classList.contains('template-cart')) {
        const mattressUpsell = document.querySelector('.cart-mattress-upsell'),
          headboardUpsell = document.querySelector('.cart-headboard-upsell');

        // Check if any items are mattress or headboard
        var hasMattress = false;
        var hasHeadboard = false;

        for (const item of data.items) {
          const downcaseItemTitle = item.title.toLowerCase();
          if (downcaseItemTitle.includes('mattress')) {
            hasMattress = true;
          }
          if (downcaseItemTitle.includes('headboard')) {
            hasHeadboard = true;
          }
        }

        if (hasMattress == true) {
          if (mattressUpsell) {
            mattressUpsell.classList.add('hidden');
          }
        } else {
          if (mattressUpsell) {
            mattressUpsell.classList.remove('hidden');
          }
        }

        if (hasHeadboard == true) {
          if (headboardUpsell) {
            headboardUpsell.classList.add('hidden');
          }
        } else {
          if (headboardUpsell) {
            headboardUpsell.classList.remove('hidden');
          }
        }

        if (hasMattress == true && hasHeadboard == true) {
          if (document.querySelector('.cart-page-upsell')) {
            document.querySelector('.cart-page-upsell').classList.add('hidden');
          }
        } else {
          if (document.querySelector('.cart-page-upsell')) {
            document.querySelector('.cart-page-upsell').classList.remove('hidden');
          }
        }
      }

      if (window.theme?.snapFinanceWidget?.updateCart) {
        window.theme.snapFinanceWidget.updateCart(data.total_price);
      }

      // Pay now / Payments from block above checkout (assets/cart-finance.js)
      window.theme?.cartFinance?.update?.(data.total_price);
    }

    /**
     * Returns true when a cart line is an optional extra.
     * Matches the skip rules used when rendering cart cards.
     * @param {object} item
     * @returns {boolean}
     */
    isAddonLine(item) {
      if (!item) return false;

      const props = item.properties || {};
      if (props._cb_addon_type) return true;
      if (props._loxaInsuranceCodeSep) return true;

      const handle = item.handle || '';
      return (
        handle === 'professional-assembly' ||
        handle === 'remove-recycle'
      );
    }

    /**
     * Cart keys Liquid marked as mattress extras that must not charge
     * while a bedframe is in the cart.
     * @returns {string[]}
     */
    getStaleMattressAddonKeys() {
      return [
        ...new Set(
          [...document.querySelectorAll('[data-cb-stale-addon-key]')]
            .map((el) => el.getAttribute('data-cb-stale-addon-key'))
            .filter(Boolean)
        ),
      ];
    }

    /**
     * Removes Liquid-identified mattress Assembly/Disposal lines.
     * @returns {Promise<{removed: boolean, cart?: object}>}
     */
    removeStaleMattressAddons() {
      const keys = this.getStaleMattressAddonKeys();
      if (!keys.length || this._staleAddonCleanupRunning) {
        return Promise.resolve({ removed: false });
      }

      this._staleAddonCleanupRunning = true;

      return new Promise((resolve) => {
        this.updateCart(keys, 0, (cart) => {
          this._staleAddonCleanupRunning = false;
          resolve({ removed: true, cart });
        });
      }).catch((error) => {
        console.error(error);
        this._staleAddonCleanupRunning = false;
        return { removed: false };
      });
    }

    /**
     * First addon line still keyed to a parent line id rather than a variant.
     * @param {object} cart
     * @returns {object|null}
     */
    findLegacyAddonItem(cart) {
      if (!cart || !Array.isArray(cart.items)) {
        return null;
      }

      return (
        cart.items.find((item) => {
          const props = item.properties || {};
          return (
            props._cb_addon_type &&
            props._cb_parent_line_id &&
            !props._cb_parent_variant_id
          );
        }) || null
      );
    }

    /**
     * Re-keys an addon that still carries _cb_parent_line_id onto its parent's
     * variant, or drops it when that parent has left the cart. Converting
     * rather than deleting keeps a charge the customer opted into.
     * @param {object} cart
     * @param {object} addon
     * @returns {Promise<object>}
     */
    migrateLegacyAddon(cart, addon) {
      const parentLineId = addon.properties._cb_parent_line_id;
      const parent = cart.items.find((item) => {
        if (this.isAddonLine(item)) return false;
        return item.properties?._cb_line_id === parentLineId;
      });

      if (!parent) {
        return new Promise((resolve) => {
          this.updateCart(addon.key, 0, resolve);
        });
      }

      const properties = Object.assign({}, addon.properties, {
        _cb_parent_variant_id: String(parent.variant_id),
        _cb_parent_line_id: null,
      });

      return fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          id: addon.key,
          quantity: addon.quantity,
          properties: properties,
        }),
      }).then((response) => response.json());
    }

    /**
     * Brings addons created before variant keying onto the new property.
     * One per pass, since each change.js re-keys the line it touches.
     * @param {number} [pass]
     * @returns {Promise<{migrated: boolean, cart?: object}>}
     */
    migrateLegacyAddons(pass = 0) {
      const maxPasses = 10;

      // The rendered cart already says whether there is anything to move
      if (pass === 0 && this._cart && !this.findLegacyAddonItem(this._cart)) {
        return Promise.resolve({ migrated: false });
      }

      return this.fetchCartJson()
        .then((cart) => {
          const legacy =
            pass < maxPasses ? this.findLegacyAddonItem(cart) : null;

          if (!legacy) {
            return { migrated: pass > 0, cart: cart };
          }

          return this.migrateLegacyAddon(cart, legacy).then(() =>
            this.migrateLegacyAddons(pass + 1)
          );
        })
        .catch((error) => {
          console.error(error);
          return { migrated: false };
        });
    }

    /**
     * After cart HTML is painted, drop stale mattress extras if Liquid asked,
     * then move any pre-variant addons onto their parent variant.
     * @param {string|null} [cartState]
     * @returns {Promise<void>}
     */
    afterCartMarkupReady(cartState) {
      return this.removeStaleMattressAddons()
        .then((result) => {
          if (!result?.removed) {
            return;
          }

          if (result.cart) {
            this.updateSummary(result.cart);
          }

          return this.repaintCartMarkup(cartState);
        })
        .then(() => this.migrateLegacyAddons())
        .then((result) => {
          if (!result?.migrated) {
            return;
          }

          if (result.cart) {
            this.updateSummary(result.cart);
          }

          return this.repaintCartMarkup(cartState);
        })
        .then(() => this.syncAddonQuantities());
    }

    /**
     * Assembly / Remove & Recycle cover every line of their bed's variant at
     * the combined quantity. Adding another of the same bed (say another
     * fabric) from the product page leaves them short, while every row of
     * that bed shows them ticked: resize them to match. Reads the cart the
     * markup was just drawn from, so a matching cart costs no request.
     */
    syncAddonQuantities() {
      if (this._writesQueued > 0 || this._qtyTimers.size > 0) return;
      // The cart the last paint came from (section renders keep _cart
      // current; the embedded JSON is only the page-load cart). The write
      // itself re-checks against the live cart, so a stale one cannot harm.
      const drawn = this._cart || this.readEmbeddedCart(document);
      const needed = drawn && this.addonQuantityUpdates(drawn);
      if (!needed) return;
      // Never retry the same fix (Shopify may cap a quantity): no loop
      const signature = JSON.stringify(needed);
      if (this._addonSyncTried === signature) return;
      this._addonSyncTried = signature;

      this.queueCartWrite((cart) => {
        const updates = this.addonQuantityUpdates(cart);
        return updates ? this.postCart('cart/update.js', { updates }) : null;
      }, 'addon-quantities', { block: false });
    }

    /**
     * @param {object} cart
     * @returns {object|null} cart/update.js updates, or null when every
     *   extra already matches its bed's total
     */
    addonQuantityUpdates(cart) {
      const totals = {};
      cart.items.forEach((item) => {
        if (this.isAddonLine(item)) return;
        totals[item.variant_id] = (totals[item.variant_id] || 0) + Number(item.quantity);
      });

      const updates = {};
      cart.items.forEach((item) => {
        const parentVariantId = item.properties?._cb_parent_variant_id;
        if (!item.properties?._cb_addon_type || !parentVariantId) return;
        const wanted = totals[parentVariantId] || 0;
        if (Number(item.quantity) !== wanted) updates[item.key] = wanted;
      });

      return Object.keys(updates).length ? updates : null;
    }

    /**
     * Cart quantity excluding optional extras
     * (assembly, disposal, Loxa).
     * @param {object} cart
     * @returns {number}
     */
    getVisibleItemCount(cart) {
      if (!cart || !Array.isArray(cart.items)) {
        return Number(cart?.item_count) || 0;
      }

      return cart.items.reduce((sum, item) => {
        if (this.isAddonLine(item)) return sum;
        return sum + (Number(item.quantity) || 0);
      }, 0);
    }

    /**
     * Updates the mini-cart header title with the current item count.
     * @param {number} count
     */
    updateMiniCartTitle(count) {
      const itemCount = Number(count) || 0;
      const template = itemCount === 1
        ? window.cartLang?.viewCartTitleOne
        : window.cartLang?.viewCartTitleOther;

      if (!template) return;

      const title = template.replace(/__COUNT__/g, String(itemCount));

      document.querySelectorAll(
        '.mini-cart-wrapper [data-cart-title]'
      ).forEach((el) => {
        el.textContent = title;
      });

      const pageTemplate = itemCount === 1
        ? window.cartLang?.cartPageTitleOne
        : window.cartLang?.cartPageTitleOther;

      if (pageTemplate) {
        const pageTitle = pageTemplate.replace(/__COUNT__/g, String(itemCount));

        document.querySelectorAll('[data-cart-page-title]').forEach((el) => {
          el.textContent = pageTitle;
        });
      }
    }

    fetchCartContents() {
      fetch(window.Shopify.routes.root + 'cart.js')
        .then(response => response.json())
        .then(data => {
          this.updateSummary(data);
        })
    }

    // Resolve the section IDs needed to repaint the cart drawer + header from a
    // bundled section render. IDs are read from the live DOM (not hardcoded) so
    // the logic survives a cart redesign or regenerated section IDs.
    getSectionsToRender() {
      const ids = [];

      const miniCartSection = this.getMiniCartSection();
      const headerSection = this.getHeaderSection();

      if (miniCartSection && miniCartSection.id) {
        ids.push(miniCartSection.id.replace('shopify-section-', ''));
      }
      if (headerSection && headerSection.id && headerSection !== miniCartSection) {
        ids.push(headerSection.id.replace('shopify-section-', ''));
      }

      return ids;
    }

    getMiniCartSection() {
      const miniCartWrapper = document.querySelector('.mini-cart-wrapper');
      return miniCartWrapper ? miniCartWrapper.closest('.shopify-section') : null;
    }

    getHeaderSection() {
      const cartBtn = this.getCartButton();
      return cartBtn ? cartBtn.closest('.shopify-section') : null;
    }

    // Repaint the drawer (items, upsell, totals) and header count from the HTML
    // returned by bundled section rendering. Returns false when the drawer
    // section could not be painted, so the caller can fall back to the legacy
    // refresh path.
    renderFromSections(sections) {
      const miniCartSection = this.getMiniCartSection();
      const headerSection = this.getHeaderSection();

      let painted = true;

      if (miniCartSection) {
        const miniCartId = miniCartSection.id.replace('shopify-section-', '');
        const miniCartHTML = sections[miniCartId];

        if (!miniCartHTML) {
          painted = false;
        } else {
          const renderedCart = this.parseCartJson(miniCartHTML);
          if (renderedCart) {
            this._cart = renderedCart;
          }

          const newDoc = new DOMParser().parseFromString(miniCartHTML, 'text/html');

          // Line items — drawer only (cart page uses a separate snippet/markup)
          const newContents = newDoc.querySelector('[data-cart-contents]');
          if (newContents) {
            const scroll = this.readCartScroll();
            const loxaRows = this.captureLoxaRows();

            document.querySelectorAll(
              '.mini-cart-wrapper [data-cart-contents]'
            ).forEach(el => {
              el.innerHTML = newContents.innerHTML;
            });

            this.restoreLoxaRows(loxaRows);
            this.restoreCartScroll(scroll);
          }

          // Totals / summary — server-rendered, already reflects the new cart.
          const oldSummary = document.querySelector('.mini-cart-summary');
          const newSummary = newDoc.querySelector('.mini-cart-summary');
          if (oldSummary && newSummary) {
            oldSummary.className = newSummary.className;
            oldSummary.innerHTML = newSummary.innerHTML;
          }

          // Delivery banner visibility tracks cart state via its classes.
          const oldDelivery = document.querySelector('.delivery-popup');
          const newDelivery = newDoc.querySelector('.delivery-popup');
          if (oldDelivery && newDelivery) {
            oldDelivery.className = newDelivery.className;
          }

          const newTitle = newDoc.querySelector('[data-cart-title]');
          if (newTitle) {
            document.querySelectorAll(
              '.mini-cart-wrapper [data-cart-title]'
            ).forEach((el) => {
              el.textContent = newTitle.textContent.trim();
            });
          }

          // Re-init drawer behaviours against the refreshed markup.
          this.refreshCartPageContents().then(() => {
            cartQuantity();
            this.initializeCartEdit();

            if (window.theme?.snapFinanceWidget?.mountAll) {
              window.theme.snapFinanceWidget.mountAll(
                document.querySelector('.mini-cart-summary') || document
              );
            }

            this.afterCartMarkupReady(null);
          });
        }
      }

      if (headerSection) {
        const headerId = headerSection.id.replace('shopify-section-', '');
        const headerHTML = sections[headerId];
        if (headerHTML) {
          const newHeaderDoc = new DOMParser().parseFromString(headerHTML, 'text/html');
          const newCount = newHeaderDoc.querySelector('[data-cart-item-count]');
          if (newCount) {
            document.querySelectorAll('[data-cart-item-count]').forEach(el => {
              el.textContent = newCount.textContent.trim();
            });
          }
        }
      }

      return painted;
    }

    /**
     * The basket page (its list is drawn by the page, not the drawer).
     * @returns {boolean}
     */
    isCartPage() {
      return !!document.querySelector('[data-cart-page-contents]') && !this.getMiniCartSection();
    }

    /**
     * Redraws the basket page list once its queued writes have landed.
     * A tap made meanwhile keeps the flag set, so its own flush redraws
     * instead and nothing it shows is undone.
     * @returns {Promise<void>}
     */
    repaintCartPage() {
      this._pageNeedsRepaint = false;
      const busy = () => this._writesQueued > 0 || this._qtyTimers.size > 0;
      return this.refreshCartPageContents(busy).then((painted) => {
        if (painted === false) {
          this._pageNeedsRepaint = true;
          return;
        }
        cartQuantity();
        this.initializeCartEdit();
        return this.afterCartMarkupReady(null);
      });
    }

    refreshCartPageContents(skipIf = null) {
      const cartPageContents = document.querySelector(
        '[data-cart-page-contents]'
      );
      if (!cartPageContents) {
        return Promise.resolve();
      }

      const scroll = this.readCartScroll();
      const loxaRows = this.captureLoxaRows();

      return fetch(window.Shopify.routes.root + 'cart?view=ajax-page')
        .then(response => response.text())
        .then(data => {
          if (skipIf && skipIf()) return false;
          document.querySelectorAll(
            '[data-cart-page-contents]'
          ).forEach(cartContent => {
            cartContent.innerHTML = data;
          });
          this.restoreLoxaRows(loxaRows);
          this.restoreCartScroll(scroll);
        });
    }

    repaintCartMarkup(cartState) {
      const scroll = this.readCartScroll();
      const loxaRows = this.captureLoxaRows();
      // The basket page has no drawer: skip its markup there
      const hasDrawer = !!document.querySelector('.mini-cart-wrapper [data-cart-contents]');
      const refreshes = [
        hasDrawer
          ? fetch(window.Shopify.routes.root + 'cart?view=ajax')
              .then(response => response.text())
              .then(data => {
                document.querySelectorAll(
                  '.mini-cart-wrapper [data-cart-contents]'
                ).forEach(cartContent => {
                  cartContent.innerHTML = data;
                });
                this.restoreLoxaRows(loxaRows);
                this.restoreCartScroll(scroll);
              })
          : Promise.resolve(),
        this.refreshCartPageContents(),
      ];

      return Promise.all(refreshes).then(() => {
        cartQuantity();
        this.initializeCartEdit();
        if (cartState !== null) {
          this.toggleCart(cartState);
        }
      });
    }

    refreshCart(cartState) {
      return this.repaintCartMarkup(cartState).then(() =>
        this.afterCartMarkupReady(cartState)
      );
    }

    removeProduct(itemKey) {
      document.querySelectorAll(`.cart-item[data-cart-key-id="${itemKey}"]`).forEach((element) => {
        element.remove();
      });
    }

    updateCart(itemKeys, quantity, callback = null) {
      var formData = { updates: {} };

      let keysArray = Array.isArray(itemKeys) ? itemKeys : [itemKeys];
      let quantityArray = Array.isArray(quantity) ? quantity : [quantity];

      if (quantityArray.length === 1 && keysArray.length > 1) {
        quantityArray = Array(keysArray.length).fill(quantityArray[0]);
      }

      keysArray.forEach((itemKey, index) => {
        formData.updates[itemKey] = quantityArray[index];
      });

      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
        .then(response => response.json())
        .then(data => {
          if (callback !== null) {
            callback(data)
          }
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    }

    /**
     * Cart JSON embedded in mini-cart section HTML, or null.
     * @param {string} html
     * @returns {object|null}
     */
    parseCartJson(html) {
      const match = /<script[^>]*\bdata-cart-json\b[^>]*>([\s\S]*?)<\/script>/.exec(html || '');
      return match ? this.parseCartText(match[1]) : null;
    }

    /**
     * @param {string} text - Cart JSON
     * @returns {object|null}
     */
    parseCartText(text) {
      try {
        const cart = JSON.parse(text);
        return cart && Array.isArray(cart.items) ? cart : null;
      } catch (error) {
        return null;
      }
    }

    /**
     * Cart JSON the mini-cart (or the basket page) rendered with on page
     * load, or null.
     * @param {Document} root
     * @returns {object|null}
     */
    readEmbeddedCart(root) {
      const script = root.querySelector(
        '.mini-cart-wrapper script[data-cart-json], .cart-wrapper script[data-cart-json]'
      );
      return script ? this.parseCartText(script.textContent) : null;
    }

    /**
     * True when the drawer (or, on the basket page, the page list) was
     * painted from this cart: same product lines at the same quantities, and
     * the same extras ticked. Anything that changed the cart behind its back
     * fails this.
     * @param {object} cart
     * @returns {boolean}
     */
    cartMatchesDrawer(cart) {
      const list =
        document.querySelector('.mini-cart-wrapper [data-cart-contents]') ||
        document.querySelector('[data-cart-page-contents]');
      if (!list) return false;
      const rows = [...list.querySelectorAll('.cart-item')];
      const lines = cart.items.filter((item) => !this.isAddonLine(item));
      if (rows.length !== lines.length) return false;

      const rowsMatch = rows.every((row) => {
        const line = lines.find((item) => item.key === row.getAttribute('data-cart-key-id'));
        return line && Number(line.quantity) === Number(row.getAttribute('data-line-quantity'));
      });
      if (!rowsMatch) return false;

      return [...list.querySelectorAll('[data-cart-addon-checkbox]')].every((box) => {
        const root = box.closest('[data-cart-item-addons]');
        const parentVariantId = root ? root.getAttribute('data-parent-variant-id') : '';
        const linked = this.getVariantAddonItem(cart, parentVariantId, box.dataset.addonType);
        const renderedKey = box.dataset.addonKey || '';
        return renderedKey ? !!linked && linked.key === renderedKey : !linked;
      });
    }

    /**
     * Cart to build the next write from. Uses the cart the drawer was
     * rendered from, or the one the previous write returned, and only reads
     * /cart.js when neither can be trusted.
     * @returns {Promise<object>}
     */
    getCart() {
      if (this._cart && (this._batchCartFresh || this.cartMatchesDrawer(this._cart))) {
        return Promise.resolve(this._cart);
      }

      return this.fetchCartJson().then((cart) => {
        this._cart = cart;
        return cart;
      });
    }

    /**
     * True when the drawer can be repainted from section HTML returned with
     * a cart write.
     * @returns {boolean}
     */
    canRenderSections() {
      return !!this.getMiniCartSection() && this.getSectionsToRender().length > 0;
    }

    /**
     * Posts a cart write. Quantity and remove ask Shopify for drawer HTML
     * in the same response. Extras skip that so the open list is not rebuilt.
     * @param {string} endpoint - e.g. 'cart/update.js'
     * @param {object} body
     * @param {{sections?: boolean}} [options] - Pass `{ sections: false }`
     *   for a JSON-only write
     * @returns {Promise<object>}
     */
    postCart(endpoint, body, options = {}) {
      const payload = Object.assign({}, body);

      if (options.sections !== false) {
        const miniCartSection = this.getMiniCartSection();
        if (miniCartSection) {
          payload.sections = miniCartSection.id.replace(
            'shopify-section-',
            ''
          );
          payload.sections_url = window.location.pathname;
        }
      }

      return fetch(window.Shopify.routes.root + endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(payload),
      }).then((response) =>
        response.json().then((data) => {
          if (!response.ok || data.status) {
            throw new Error(
              data.description || data.message || 'Cart write failed'
            );
          }
          return data;
        })
      );
    }

    /**
     * True when the payload is a full cart.js / cart/update.js object.
     * cart/add.js only returns the lines just added.
     * @param {object} data
     * @returns {boolean}
     */
    isFullCart(data) {
      return !!(
        data &&
        typeof data.item_count === 'number' &&
        Array.isArray(data.items)
      );
    }

    /**
     * @param {object} data - A write response
     * @returns {Promise<object>}
     */
    ensureFullCart(data) {
      if (this.isFullCart(data)) {
        return Promise.resolve(data);
      }

      return this.fetchCartJson();
    }

    /**
     * A Protection save rewrites the product line's properties, which
     * re-keys it, without repainting the list. Moves each row (and its
     * Protection row) onto its line's new key so the next tap still
     * matches the cart it shows.
     * @param {object} cart
     */
    syncRowKeys(cart) {
      const lines = cart.items.filter((item) => !this.isAddonLine(item));
      const keys = new Set(lines.map((item) => item.key));
      const rows = [...document.querySelectorAll('.cart-item[data-cart-key-id]')];
      const used = new Set(rows.map((row) => row.getAttribute('data-cart-key-id')).filter((key) => keys.has(key)));

      rows.forEach((row) => {
        let key = row.getAttribute('data-cart-key-id');
        if (!keys.has(key)) {
          const line = lines.find(
            (item) => !used.has(item.key) && String(item.variant_id) === row.getAttribute('data-variant-id')
          );
          if (!line) return;
          const oldKey = key;
          key = line.key;
          used.add(key);
          row.setAttribute('data-cart-key-id', key);
          row.querySelectorAll(`[data-key="${CSS.escape(oldKey)}"]`).forEach((el) => {
            el.setAttribute('data-key', key);
          });
        }

        const loxaRow = row.querySelector('[data-loxa-row]');
        if (!loxaRow) return;
        const line = lines.find((item) => item.key === key);
        const link = line?.properties?._loxaLinkId;
        const cover = link
          ? cart.items.find((item) => item.properties?._loxaInsuranceCodeSep && item.properties._loxaLinkId === link)
          : null;
        loxaRow.setAttribute('data-loxa-line-key', key);
        if (cover) {
          loxaRow.setAttribute('data-loxa-cover-key', cover.key);
          loxaRow.setAttribute('data-loxa-state', 'covered');
        } else {
          loxaRow.removeAttribute('data-loxa-cover-key');
        }
      });
    }

    /**
     * Writes each extra's cart line key onto its checkbox so the next
     * untick can update.js without a list replace.
     * @param {object} cart
     */
    syncAddonCheckboxKeys(cart) {
      document.querySelectorAll('[data-cart-addon-checkbox]').forEach((box) => {
        const root = box.closest('[data-cart-item-addons]');
        const parentVariantId = root
          ? root.getAttribute('data-parent-variant-id')
          : '';
        const linked = this.getVariantAddonItem(
          cart,
          parentVariantId,
          box.dataset.addonType
        );

        // Runs once every write has landed, so the cart is what the
        // customer asked for: ticks follow it
        box.checked = !!linked;

        if (linked) {
          box.dataset.addonKey = linked.key;
          return;
        }

        delete box.dataset.addonKey;
        box.removeAttribute('data-addon-key');
      });
    }

    /**
     * Every checkbox for one extra on one variant, across rows, drawer and
     * basket page.
     * @param {string|number} parentVariantId
     * @param {string} addonType
     * @returns {HTMLInputElement[]}
     */
    addonBoxesFor(parentVariantId, addonType) {
      return [...document.querySelectorAll('[data-cart-addon-checkbox]')].filter((box) => {
        const root = box.closest('[data-cart-item-addons]');
        return (
          box.dataset.addonType === addonType &&
          String(root?.getAttribute('data-parent-variant-id')) === String(parentVariantId)
        );
      });
    }

    /**
     * Scroll positions for the drawer list and cart page, so a fallback
     * innerHTML replace can put the customer back where they were.
     * @returns {{el: Element, top: number}[]}
     */
    readCartScroll() {
      return [
        ...document.querySelectorAll(
          '.mini-cart-wrapper .mini-cart-contents, [data-cart-contents], [data-cart-page-contents]'
        ),
      ].map((el) => ({ el, top: el.scrollTop }));
    }

    /**
     * @param {{el: Element, top: number}[]} saved
     */
    restoreCartScroll(saved) {
      if (!saved) return;

      saved.forEach((entry) => {
        if (entry.el.isConnected) {
          entry.el.scrollTop = entry.top;
        }
      });
    }

    /**
     * Loxa row quote state before a list replace, keyed by line then variant.
     * @returns {object[]}
     */
    captureLoxaRows() {
      return [...document.querySelectorAll('[data-loxa-row]')].map((row) => {
        const priceEl = row.querySelector('[data-loxa-price]');
        const labelEl = row.querySelector('[data-loxa-label]');

        return {
          variantId: row.getAttribute('data-loxa-variant-id') || '',
          lineKey: row.getAttribute('data-loxa-line-key') || '',
          state: row.getAttribute('data-loxa-state') || '',
          resolved: row.hasAttribute('data-loxa-resolved'),
          price: priceEl ? priceEl.textContent : '',
          label: labelEl ? labelEl.textContent : '',
        };
      });
    }

    /**
     * Copies a quoted Protection row onto the new markup so it does not
     * go pending and hide again.
     * @param {object[]} saved
     */
    restoreLoxaRows(saved) {
      if (!saved || !saved.length) return;

      document.querySelectorAll('[data-loxa-row]').forEach((row) => {
        const variantId = row.getAttribute('data-loxa-variant-id') || '';
        const lineKey = row.getAttribute('data-loxa-line-key') || '';
        const match = saved.find((item) => {
          if (lineKey && item.lineKey === lineKey) return true;
          return !!(variantId && item.variantId === variantId);
        });

        if (!match || !match.state || match.state === 'pending') return;

        row.setAttribute('data-loxa-state', match.state);

        if (match.resolved) {
          row.setAttribute('data-loxa-resolved', '1');
        }

        const priceEl = row.querySelector('[data-loxa-price]');
        const labelEl = row.querySelector('[data-loxa-label]');

        if (priceEl && match.price) {
          priceEl.textContent = match.price;
        }

        if (labelEl && match.label) {
          labelEl.textContent = match.label;
        }
      });
    }

    /**
     * @param {{keys: string[], quantities: number[]}} updates
     * @returns {object} - cart/update.js updates object
     */
    toUpdatesObject(updates) {
      const result = {};
      updates.keys.forEach((key, index) => {
        result[key] = updates.quantities[index];
      });
      return result;
    }

    /**
     * Shows the drawer is saving: totals dim and checkout waits until every
     * change has landed.
     * @param {boolean} on
     */
    setCartSyncing(on) {
      // Read by the next page (checkUnfinishedSave) if this one closes mid-save
      try {
        if (on) sessionStorage.setItem(SAVE_IN_FLIGHT_KEY, '1');
        else sessionStorage.removeItem(SAVE_IN_FLIGHT_KEY);
      } catch (error) {
        // Storage blocked: the next page trusts its own render
      }
      document.querySelectorAll('.mini-cart-wrapper, .cart-wrapper').forEach((wrapper) => {
        wrapper.classList.toggle('is-syncing', on);
        if (!on) {
          wrapper.classList.remove('has-estimated-total');
        }
      });

      if (!on) {
        this._estimatedTotals = null;
        this.setAddonLoading(false);
        // A write may have changed a bed's quantity behind its extras (the
        // product page's own extras, say): check once the queue is empty
        setTimeout(() => this.syncAddonQuantities(), 0);
      }
    }

    /**
     * Marks a cart write as in flight so extras, quantity and remove cannot
     * overlap: the overlay goes up at once, invisible, to block taps. The
     * fade and loading wheel only appear when a write is genuinely slow
     * (ADDON_SPINNER_DELAY, or ADDON_SPINNER_DELAY_INSTANT when the new total
     * already shows); quick saves never flash them.
     * @param {boolean} on
     * @param {boolean} [block=true] - Raise the invisible tap-blocking
     *   overlay. Assembly / Remove & Recycle skip it: their total shows at
     *   the tap and later taps queue behind the save.
     */
    setAddonLoading(on, block = true) {
      this._addonLoading = !!on;
      this._addonBlocking = !!on && block;
      this._addonLoadingTimers.forEach(clearTimeout);
      this._addonLoadingTimers = [];

      document.querySelectorAll('.mini-cart-wrapper, .cart-wrapper').forEach((wrapper) => {
        wrapper.classList.toggle('is-addon-busy', this._addonBlocking);
      });

      if (on) {
        this._addonLoadingTimers = [
          setTimeout(() => this._addonLoading && this.showLoadingOverlay(true, false), ADDON_SPINNER_DELAY),
          setTimeout(() => this._addonLoading && this.showLoadingOverlay(true, true), ADDON_SPINNER_DELAY_INSTANT),
        ];
      } else {
        this.showLoadingOverlay(false);
        this.clearAddonRowSaving();
      }
    }

    /**
     * Stops the tapped extra's spinner (markAddonRowSaving).
     */
    clearAddonRowSaving() {
      document.querySelectorAll('.cart-item__addon-row.is-saving').forEach((row) => {
        row.classList.remove('is-saving');
      });
      document.querySelectorAll('.has-row-saving').forEach((wrapper) => {
        wrapper.classList.remove('has-row-saving');
      });
    }

    /**
     * Spins a small wheel beside the extra the customer just tapped, so the
     * tap answers at once while it saves. The full overlay wheel then only
     * comes on a real stall (ADDON_SPINNER_DELAY_INSTANT).
     * @param {Element} box - The extra's checkbox
     */
    markAddonRowSaving(box) {
      const row = box.closest('.cart-item__addon-row');
      if (!row) return;
      row.classList.add('is-saving');
      document.querySelectorAll('.mini-cart-wrapper, .cart-wrapper').forEach((wrapper) => {
        wrapper.classList.add('has-row-saving');
      });
    }

    /**
     * Shows or hides the loading wheel overlay on the basket drawer and the
     * basket page (each has a [data-cart-loading] overlay).
     * @param {boolean} on
     * @param {boolean} [includeInstant] - Also where the new total already shows
     */
    showLoadingOverlay(on, includeInstant = false) {
      document.querySelectorAll('.mini-cart-wrapper, .cart-wrapper').forEach((wrapper) => {
        // The new total already shows (paintEstimatedTotal), or the tapped
        // extra spins its own wheel (markAddonRowSaving): only a real stall
        // (ADDON_SPINNER_DELAY_INSTANT) shows the overlay wheel
        const instant =
          wrapper.classList.contains('has-estimated-total') ||
          wrapper.classList.contains('has-row-saving');
        wrapper.classList.toggle('is-addon-loading', on && (includeInstant || !instant));
        wrapper.setAttribute('aria-busy', on ? 'true' : 'false');

        const overlay = wrapper.querySelector('[data-cart-loading]');
        if (overlay) {
          overlay.setAttribute('aria-hidden', on ? 'false' : 'true');
        }
      });
    }

    /**
     * True when an extra's price can be added to the total before Shopify
     * confirms it: no order-level discount, and no extra already in the cart
     * carries a discount (EXTRA15 and similar codes only touch the products).
     * If a code did cover the new extra, the saved total replaces the
     * estimate about a second later.
     * @param {object} cart
     * @returns {boolean}
     */
    canEstimateAddonTotal(cart) {
      if (!cart) return false;
      if ((cart.cart_level_discount_applications || []).length) return false;
      const discountedExtra = cart.items.some(
        (item) => this.isAddonLine(item) && Number(item.total_discount) > 0
      );
      if (discountedExtra) return false;
      return this.cartMatchesDrawer(cart);
    }

    /**
     * Paints a total the customer's tap will produce, on the drawer and the
     * basket page, and moves the finance figures with it.
     * @param {object} base - The cart the lists were drawn from, or the
     *   totals the previous tap painted
     * @param {number} delta - Pence added (or taken off) by the tap
     */
    paintEstimatedTotal(base, delta) {
      const total = Number(base.total_price) + delta;
      this._estimatedTotals = {
        total_price: total,
        original_total_price: Number(base.original_total_price) + delta,
        items_subtotal_price: Number(base.items_subtotal_price) + delta,
      };
      const values = {
        '[data-cart-subtotal]': this._estimatedTotals.original_total_price,
        '[data-cart-items-subtotal]': this._estimatedTotals.items_subtotal_price,
      };

      document.querySelectorAll('[data-cart-total]').forEach((el) => {
        el.setAttribute('data-cart-total', total);
        el.innerHTML = formatMoney(total, window.theme.moneyFormat);
      });
      for (const [selector, value] of Object.entries(values)) {
        document.querySelectorAll(selector).forEach((el) => {
          el.innerHTML = formatMoney(value, window.theme.moneyFormat);
        });
      }
      document.querySelectorAll('.mini-cart-wrapper, .cart-wrapper').forEach((wrapper) => {
        wrapper.classList.add('has-estimated-total');
      });
      window.theme?.cartFinance?.update?.(total);
    }

    /**
     * Shows the new total straight away when ticking or unticking Assembly /
     * Remove & Recycle, whose price is fixed.
     * @param {HTMLInputElement} box - The extra's checkbox, already toggled
     * @param {string} parentVariantId
     */
    showEstimatedAddonTotal(box, parentVariantId) {
      const cart = this._cart;
      if (!this.canEstimateAddonTotal(cart) || this._qtyTimers.size > 0) return false;

      // Taps while earlier extras still save build on the totals they
      // painted; anything else in flight (quantity, remove, Protection)
      // waits for the real figure
      const chained = this._writesQueued > 0;
      if (chained && (this._loudWrites > 0 || !this._estimatedTotals)) return false;

      const unitPrice = Number(box.dataset.addonPrice);
      const quantity = this.getVariantTotalQuantity(cart, parentVariantId);
      if (!unitPrice || !quantity) return false;

      let delta = 0;
      if (chained) {
        // Extras are never discounted (canEstimateAddonTotal), so a line
        // costs its unit price times the bed quantity
        delta = (box.checked ? 1 : -1) * unitPrice * quantity;
      } else {
        const existing = this.getVariantAddonItem(cart, parentVariantId, box.dataset.addonType);
        if (box.checked) {
          if (existing) return false;
          delta = unitPrice * quantity;
        } else {
          if (!existing) return false;
          delta = -Number(existing.final_line_price);
        }
      }

      this.paintEstimatedTotal(chained ? this._estimatedTotals : cart, delta);
      return true;
    }

    /**
     * The same for Protection: its quoted premium is already on the row, so
     * the total moves at the tap instead of after the two-step Loxa save.
     * @param {HTMLInputElement} box - The Protection checkbox, already toggled
     */
    showEstimatedLoxaTotal(box) {
      const cart = this._cart;
      const row = box.closest('[data-loxa-row]');
      if (!row || !this.canEstimateAddonTotal(cart)) return;
      if (this._writesQueued > 0 || this._qtyTimers.size > 0) return;

      let delta = 0;
      if (box.checked) {
        const unit = parseFloat((row.querySelector('[data-loxa-price]')?.textContent || '').replace(/[^0-9.]/g, ''));
        const quantity = Number(row.getAttribute('data-loxa-line-quantity')) || 1;
        if (!unit || row.getAttribute('data-loxa-cover-key')) return;
        delta = Math.round(unit * 100) * quantity;
      } else {
        const coverKey = row.getAttribute('data-loxa-cover-key');
        const cover = coverKey && cart.items.find((item) => item.key === coverKey);
        if (!cover) return;
        delta = -Number(cover.final_line_price);
      }

      this.paintEstimatedTotal(cart, delta);
    }

    /**
     * Runs drawer writes one at a time, each built from the latest cart. The
     * customer's tap shows straight away. Extras flush totals only; quantity
     * and remove still repaint once the last queued write (and any quantity
     * still being tapped) has landed, so a repaint never undoes a change
     * they have just made.
     * @param {function(object): (Promise<object>|null)} task - Gets the
     *   latest cart; resolves with the write response, or null for no write
     * @param {string} [supersedeKey] - Writes sharing a key (one extra on one
     *   product) only send the newest: tapping on, off, on sends one write
     * @param {{quiet?: boolean, block?: boolean}} [options] - quiet: the new
     *   total already shows, so nothing spins (the stall wheel still can).
     *   block: false leaves taps on extras free while it saves; they queue
     *   behind it and are built from the cart it returns.
     */
    queueCartWrite(task, supersedeKey, { quiet = false, block = !quiet } = {}) {
      this._writesQueued++;
      if (!quiet) this._loudWrites++;
      this.setCartSyncing(true);
      if (block) {
        this.setAddonLoading(true);
      } else if (!this._addonBlocking) {
        this.setAddonLoading(true, false);
      }

      let token = 0;
      if (supersedeKey) {
        token = (this._writeTokens.get(supersedeKey) || 0) + 1;
        this._writeTokens.set(supersedeKey, token);
      }
      const superseded = () =>
        supersedeKey && this._writeTokens.get(supersedeKey) !== token;

      const run = () =>
        this.getCart()
          .then((cart) => (superseded() ? null : task(cart)))
          .then((data) => {
            if (!data) return;

            // Shopify has the change: the tapped extra stops spinning now.
            // Reading back the cart for exact totals carries on behind it.
            if (this._writesQueued === 1) this.clearAddonRowSaving();

            // Full cart JSON (cart/update.js, or extras add after
            // ensureFullCart). Keep sections only when this write asked
            // for them — a later extras write must not paint stale HTML.
            if (this.isFullCart(data)) {
              this._cart = data;
              this._batchCartFresh = true;
              this._latestSections = data.sections || null;
              this._batchNeedsRefresh = false;
              return;
            }

            if (data.sections) {
              this._latestSections = data.sections;
              const miniCartSection = this.getMiniCartSection();
              const miniCartId = miniCartSection
                ? miniCartSection.id.replace('shopify-section-', '')
                : '';
              const renderedCart = this.parseCartJson(data.sections[miniCartId]);
              if (renderedCart) {
                this._cart = renderedCart;
                this._batchCartFresh = true;
                return;
              }
            }

            // Wrote, but the response is not a full cart (e.g. cart/add.js
            // extras). Read /cart.js so the next write and flush have totals.
            return this.fetchCartJson().then((cart) => {
              this._cart = cart;
              this._batchCartFresh = true;
              this._latestSections = null;
              this._batchNeedsRefresh = false;
            });
          });

      this._cartQueue = this._cartQueue
        .then(run)
        .catch((error) => {
          console.error(error);
          this._latestSections = null;
          this._cart = null;
          this._batchNeedsRefresh = true;
          this._batchCartFresh = false;
        })
        .then(() => {
          this._writesQueued--;
          if (!quiet) this._loudWrites--;
          this.flushCartWrites();
        });

      return this._cartQueue;
    }

    /**
     * Paints the drawer once nothing is left to send.
     */
    flushCartWrites() {
      if (this._writesQueued > 0 || this._qtyTimers.size > 0) return;

      const sections = this._latestSections;
      const needsRefresh = this._batchNeedsRefresh;
      const cartFresh = this._batchCartFresh;
      this._latestSections = null;
      this._batchNeedsRefresh = false;
      this._batchCartFresh = false;

      // Extras writes skip section HTML. Confirm totals and line keys on
      // the open list instead of replacing it.
      if (cartFresh && this._cart && !sections && !needsRefresh) {
        this.updateSummary(this._cart);
        this.syncAddonCheckboxKeys(this._cart);
        this.syncRowKeys(this._cart);
        // Basket page quantity / remove: line prices and rows come from
        // the page markup, so redraw it once (checkout waits for that)
        if (this._pageNeedsRepaint && this.isCartPage()) {
          const busy = () => this._writesQueued > 0 || this._qtyTimers.size > 0;
          this.repaintCartPage()
            .catch((error) => console.error(error))
            .then(() => {
              if (!busy()) this.setCartSyncing(false);
            });
          return;
        }
        this.setCartSyncing(false);
        return;
      }

      // Sections from the last write are the cart as it now stands, so they
      // supersede any earlier write that could not be painted
      if (sections && this.renderFromSections(sections)) {
        if (this._cart) {
          this.updateSummary(this._cart);
        }
        this.setCartSyncing(false);
        return;
      }

      if (!needsRefresh && !sections) {
        // Nothing was written
        this.setCartSyncing(false);
        return;
      }

      // A write failed or could not be painted: redraw from the live cart so
      // nothing shows a change that did not land
      const busy = () => this._writesQueued > 0 || this._qtyTimers.size > 0;
      this.fetchCartJson()
        .then((cart) => {
          // Newer taps since: their own flush will paint, and painting this
          // older cart now would flash their changes back
          if (busy()) return;
          this.updateSummary(cart);
          return this.refreshCart(null);
        })
        .catch((error) => console.error(error))
        .then(() => {
          if (!busy()) this.setCartSyncing(false);
        });
    }

    /**
     * Total quantity of a variant across every non-addon cart line.
     * Shopify splits one line into several when a discount entitles only part
     * of the quantity, so a variant's units can span several lines.
     * @param {object} cart
     * @param {string|number} variantId
     * @returns {number}
     */
    getVariantTotalQuantity(cart, variantId) {
      if (!cart || !variantId || !Array.isArray(cart.items)) {
        return 0;
      }

      const wanted = String(variantId);

      return cart.items.reduce((sum, item) => {
        if (this.isAddonLine(item)) return sum;
        if (String(item.variant_id) !== wanted) return sum;

        return sum + (Number(item.quantity) || 0);
      }, 0);
    }

    /**
     * Finds the optional extra covering a parent variant.
     * @param {object} cart
     * @param {string|number} variantId
     * @param {string} addonType
     * @returns {object|null}
     */
    getVariantAddonItem(cart, variantId, addonType) {
      if (!cart || !variantId || !addonType || !Array.isArray(cart.items)) {
        return null;
      }

      const wanted = String(variantId);

      return (
        cart.items.find((item) => {
          const props = item.properties || {};
          return (
            props._cb_parent_variant_id === wanted &&
            props._cb_addon_type === addonType
          );
        }) || null
      );
    }

    /**
     * Cart keys for every optional extra covering a parent variant.
     * @param {object} cart
     * @param {string|number} variantId
     * @returns {string[]}
     */
    getVariantAddonKeys(cart, variantId) {
      if (!cart || !variantId || !Array.isArray(cart.items)) {
        return [];
      }

      const wanted = String(variantId);

      return cart.items
        .filter((item) => {
          const props = item.properties || {};
          return props._cb_parent_variant_id === wanted;
        })
        .map((item) => item.key);
    }

    /**
     * Reads the parent variant id from a cart item element.
     * @param {Element|null} cartItem
     * @returns {string}
     */
    getVariantIdFromElement(cartItem) {
      if (!cartItem) return '';
      return cartItem.getAttribute('data-variant-id') || '';
    }

    /**
     * Fetches live cart JSON.
     * @returns {Promise<object>}
     */
    fetchCartJson() {
      return fetch(window.Shopify.routes.root + 'cart.js').then((response) =>
        response.json()
      );
    }

    /**
     * Toggles Assembly / Disposal for a parent variant. One extra covers every
     * cart line holding that variant, at their combined quantity.
     * Writes JSON only: the checkbox and estimated total stay in place.
     * @param {Event} event
     * @param {HTMLInputElement} element
     */
    handleAddonToggle(event, element) {
      if (this._addonBlocking) {
        element.checked = !element.checked;
        return;
      }

      const cartItem = element.closest('.cart-item');
      const addonsRoot = element.closest('[data-cart-item-addons]');
      if (!cartItem || !addonsRoot) return;

      const parentVariantId =
        addonsRoot.getAttribute('data-parent-variant-id') ||
        this.getVariantIdFromElement(cartItem);
      const addonType = element.dataset.addonType;
      const variantId = element.dataset.variantId;

      if (!parentVariantId || !addonType || !variantId) return;

      const parentTitle =
        addonsRoot.getAttribute('data-parent-title') ||
        cartItem.querySelector('.cart-item__title a')?.textContent?.trim() ||
        '';

      const wantsAddon = element.checked;
      // An extra covers the variant, not one row: another row of the same
      // bed (another fabric) shows the same tick, or its next tap would
      // send the opposite of what the customer sees
      this.addonBoxesFor(parentVariantId, addonType).forEach((box) => {
        box.checked = wantsAddon;
      });
      const instant = this.showEstimatedAddonTotal(element, parentVariantId);
      this.setAddonLoading(true);
      this.showLoadingOverlay(true, true);

      this.queueCartWrite((cart) => {
        const existing = this.getVariantAddonItem(
          cart,
          parentVariantId,
          addonType
        );

        if (!wantsAddon) {
          if (!existing) return null;
          return this.postCart(
            'cart/update.js',
            { updates: { [existing.key]: 0 } },
            { sections: false }
          );
        }

        const quantity = this.getVariantTotalQuantity(cart, parentVariantId);
        if (!quantity) return null;

        // Ticking a second card for the same variant must resize the one
        // extra rather than buy another.
        if (existing) {
          if (Number(existing.quantity) === quantity) return null;
          return this.postCart(
            'cart/update.js',
            { updates: { [existing.key]: quantity } },
            { sections: false }
          );
        }

        const properties = {
          _cb_parent_variant_id: String(parentVariantId),
          _cb_addon_type: addonType,
        };
        if (parentTitle) {
          properties._For = parentTitle;
        }

        return this.postCart(
          'cart/add.js',
          {
            items: [
              {
                id: Number(variantId),
                quantity: quantity,
                properties: properties,
              },
            ],
          },
          { sections: false }
        );
        // The queue reads /cart.js after a non-cart response itself, once
        // the row has stopped spinning
      }, `addon:${parentVariantId}:${addonType}`, { quiet: instant, block: true });
    }

    /**
     * The cart line a drawer row stands for. Matched by key, or by variant
     * when the key has changed since the row was drawn: adding or removing a
     * Loxa cover rewrites the product line's properties, which re-keys it.
     * @param {object} cart
     * @param {string} itemKey - Key the row was rendered with
     * @param {string|number} variantId
     * @returns {object|null}
     */
    findRowLine(cart, itemKey, variantId) {
      const exact = cart.items.find((item) => item.key === itemKey);
      if (exact || !variantId) return exact || null;

      // Two lines can hold the same variant (another fabric): skip lines
      // other rows still show, or a stale key would land on the wrong bed
      const claimed = new Set(
        [...document.querySelectorAll('.cart-item[data-cart-key-id]')]
          .map((row) => row.getAttribute('data-cart-key-id'))
          .filter((key) => key && key !== itemKey)
      );

      return (
        cart.items.find(
          (item) =>
            !this.isAddonLine(item) &&
            String(item.variant_id) === String(variantId) &&
            !claimed.has(item.key)
        ) || null
      );
    }

    /**
     * Cart update payload that moves a parent line to a new quantity and
     * resizes its variant's optional extras to the units left behind. An extra
     * covers every line holding the variant, so it tracks their combined
     * quantity rather than the quantity of the line being edited.
     * @param {object} cart
     * @param {string} itemKey
     * @param {string|number} variantId
     * @param {number} newQuantity
     * @returns {{keys: string[], quantities: number[]}}
     */
    buildVariantAddonUpdates(cart, itemKey, variantId, newQuantity) {
      const line = (cart.items || []).find((item) => item.key === itemKey);
      const oldQuantity = Number(line?.quantity) || 0;
      const total = this.getVariantTotalQuantity(cart, variantId);
      const addonQuantity = Math.max(total - oldQuantity + newQuantity, 0);
      const addonKeys = this.getVariantAddonKeys(cart, variantId);

      return {
        keys: [itemKey, ...addonKeys],
        quantities: [newQuantity, ...addonKeys.map(() => addonQuantity)],
      };
    }

    handleRemove(event, element) {
      event.preventDefault();

      let itemKey = element.getAttribute('data-key');
      let itemVariantId = element.getAttribute('data-variant-id');
      const cartItem = element.closest('.cart-item');
      const newQuantity = 0;
      const parentVariantId =
        itemVariantId || this.getVariantIdFromElement(cartItem);

      if (this.canRenderSections() || this.isCartPage()) {
        if (this.isCartPage()) this._pageNeedsRepaint = true;
        // The row goes at once; the write follows in the background
        clearTimeout(this._qtyTimers.get(itemKey));
        this._qtyTimers.delete(itemKey);
        document.querySelectorAll(`.cart-item[data-cart-key-id="${itemKey}"]`).forEach((row) => {
          row.style.display = 'none';
        });

        this.queueCartWrite((cart) => {
          const line = this.findRowLine(cart, itemKey, parentVariantId);
          if (!line) return null;
          const updates = parentVariantId
            ? this.buildVariantAddonUpdates(cart, line.key, parentVariantId, newQuantity)
            : { keys: [line.key], quantities: [newQuantity] };
          return this.postCart('cart/update.js', { updates: this.toUpdatesObject(updates) });
        }, undefined, { block: false });

        let serviceWrapper = document.querySelector(`.service-block[data-variant-id="${itemVariantId}"]`);
        let service = document.querySelector(`.service-block__checkbox[data-variant-id="${itemVariantId}"]`);
        if (service) {
          serviceWrapper.classList.remove('hidden');
          service.checked = false;
        }
        return;
      }

      this.startLoading(true);
      this.setAddonLoading(true);

      // An extra may still be saving in the background: build on its result
      this._cartQueue.then(() => this.removeLegacy(itemKey, itemVariantId, parentVariantId, newQuantity));
    }

    /**
     * Remove without section rendering (the basket page), after any queued
     * write has landed.
     */
    removeLegacy(itemKey, itemVariantId, parentVariantId, newQuantity) {
      const finishRemove = (response) => {
        this.updateSummary(response);
        this.refreshCart('open');
        this.removeProduct(itemKey);

        let cartServiceWrapper = document.querySelector(`.service-block[data-variant-id="${itemVariantId}"]`);
        let cartService = document.querySelector(`.service-block__checkbox[data-variant-id="${itemVariantId}"]`);
        if (cartService) {
          cartServiceWrapper.classList.remove('hidden');
          cartService.checked = false;
        }

        this.endLoading();
        this.setAddonLoading(false);
      };

      if (parentVariantId) {
        this.fetchCartJson()
          .then((cart) => {
            // A Protection save may have re-keyed the line since it was drawn
            const line = this.findRowLine(cart, itemKey, parentVariantId);
            const updates = this.buildVariantAddonUpdates(
              cart,
              line ? line.key : itemKey,
              parentVariantId,
              newQuantity
            );
            this.updateCart(
              updates.keys,
              updates.quantities,
              finishRemove.bind(this)
            );
          })
          .catch((error) => {
            console.error(error);
            this.updateCart(itemKey, newQuantity, finishRemove.bind(this));
          });
        return;
      }

      this.updateCart(itemKey, newQuantity, finishRemove.bind(this));
    }

    handleQuantity(event, element) {
      let itemKey = (element.closest('.cart-item').getAttribute('data-cart-key-id'));
      const cartItem = element.closest('.cart-item');
      const parentVariantId = this.getVariantIdFromElement(cartItem);
      let quantity = parseInt(element.value, 10) || 0;

      if (this.canRenderSections() || this.isCartPage()) {
        if (this.isCartPage()) this._pageNeedsRepaint = true;
        // The number shows at once. Taps settle briefly so several presses
        // send one update for the final quantity.
        clearTimeout(this._qtyTimers.get(itemKey));
        this.setCartSyncing(true);
        // Extras taps stay free: they queue behind this write
        if (!this._addonBlocking) this.setAddonLoading(true, false);
        this._qtyTimers.set(
          itemKey,
          setTimeout(() => {
            this._qtyTimers.delete(itemKey);
            this.queueCartWrite((cart) => {
              const line = this.findRowLine(cart, itemKey, parentVariantId);
              if (!line) return null;
              const updates = parentVariantId
                ? this.buildVariantAddonUpdates(cart, line.key, parentVariantId, quantity)
                : { keys: [line.key], quantities: [quantity] };
              return this.postCart('cart/update.js', { updates: this.toUpdatesObject(updates) });
            }, undefined, { block: false });
          }, 200)
        );
        return;
      }

      this.startLoading();
      this.setAddonLoading(true);

      // An extra may still be saving in the background: build on its result
      this._cartQueue.then(() => this.quantityLegacy(itemKey, parentVariantId, quantity));
    }

    /**
     * Quantity change without section rendering (the basket page), after
     * any queued write has landed.
     */
    quantityLegacy(itemKey, parentVariantId, quantity) {
      const finishQuantity = function (response) {
        this.updateSummary(response);
        this.refreshCart('open');
        this.endLoading();
        this.setAddonLoading(false);
      }.bind(this);

      if (parentVariantId) {
        this.fetchCartJson()
          .then((cart) => {
            // A Protection save may have re-keyed the line since it was drawn
            const line = this.findRowLine(cart, itemKey, parentVariantId);
            const updates = this.buildVariantAddonUpdates(
              cart,
              line ? line.key : itemKey,
              parentVariantId,
              quantity
            );
            this.updateCart(updates.keys, updates.quantities, finishQuantity);
          })
          .catch((error) => {
            console.error(error);
            this.updateCart(itemKey, quantity, finishQuantity);
          });
        return;
      }

      this.updateCart(itemKey, quantity, finishQuantity);
    }

    _clearAtcAnimTimers(button) {
      const timers = this._atcAnimTimers.get(button);
      if (!timers) {
        return;
      }

      if (timers.stage2Timer) {
        clearTimeout(timers.stage2Timer);
      }
      if (timers.stage3Timer) {
        clearTimeout(timers.stage3Timer);
      }
      if (timers.revertTimer) {
        clearTimeout(timers.revertTimer);
      }

      this._atcAnimTimers.delete(button);
    }

    _resetAtcAnim(button) {
      if (!button) {
        return;
      }

      this._clearAtcAnimTimers(button);
      button.removeAttribute('data-added');
      button.removeAttribute('data-stage');
    }

    _startAtcAnim(button) {
      this._clearAtcAnimTimers(button);
      button.removeAttribute('data-stage');
      button.setAttribute('data-added', 'true');

      const duration = this._atcAnimDurationMs;
      button.style.setProperty('--atc-animation-duration', duration + 'ms');
      const stepMs = duration / 3;
      const timers = {};

      timers.stage2Timer = setTimeout(() => {
        button.setAttribute('data-stage', '2');
      }, stepMs);

      timers.stage3Timer = setTimeout(() => {
        button.setAttribute('data-stage', '3');
      }, stepMs * 2);

      timers.revertTimer = setTimeout(() => {
        this._resetAtcAnim(button);
      }, duration);

      this._atcAnimTimers.set(button, timers);
    }

    /**
     * ATC button micro-animation — runs independently of cart AJAX.
     * Fixed 2s sequence (3 equal steps) on start; reset on error only.
     *
     * @param {'start'|'error'|'reset'} step
     * @param {Event} event
     * @param {HTMLElement} element - clicked node or [data-cart-add] button
     */
    handleAddToCartAnimation(step, event, element) {
      const button = element?.closest?.('[data-cart-add].btn-add-to-cart') || element;
      if (!button || !button.matches('[data-cart-add].btn-add-to-cart')) {
        return false;
      }

      if (!button.querySelector('.btn-success-content')) {
        return false;
      }

      if (step === 'start') {
        if (button.disabled) {
          return false;
        }

        this._startAtcAnim(button);
        return true;
      }

      if (step === 'error' || step === 'reset') {
        this._resetAtcAnim(button);
        return true;
      }

      return false;
    }

    handleAdd(event, element) {
      event.preventDefault();

      // Get the form that contains the clicked button
      const form = element.closest('form');
      if (!form) {
        return;
      }
      let formData = new FormData(form);

      let formbutton = form.querySelector('[data-cart-add]');
      if (!formbutton) {
        return;
      }

      // One add per form at a time, so a quick double click adds once
      if (form.dataset.cartAdding === 'true') {
        return;
      }
      form.dataset.cartAdding = 'true';

      // Edit / Overview with the same size and storage: change the line in
      // place, which keeps its extras and Protection
      if (formbutton.classList.contains('btn-cart-edit') && this.editLineInPlace(form, formData, formbutton)) {
        return;
      }

      // ATC animation — independent 2s sequence on click (not tied to cart AJAX).
      this.handleAddToCartAnimation('start', event, formbutton);

      let itemIndex = 0;

      if (formbutton.classList.contains('btn-main-add-to-cart')) {
        // Match the chosen mattress / headboard to the size and colour on
        // the page now, in case they changed after picking
        if (typeof window.syncSelectedUpsells === 'function') {
          window.syncSelectedUpsells();
        }

        //
        //  LM: Upsell - Mattress
        //
        const mattressUpsell = document.querySelector('.selected-mattress-upsell:not(.hidden)');
  if (mattressUpsell) {
      const mattressVariantId = mattressUpsell.getAttribute('data-variant-id');
      const mattressQuantity = mattressUpsell.getAttribute('data-variant-quantity');                                                  
      const mattressTitle = document.querySelector('.product__block--product_title h1').textContent;
                                                                                                                                      
      if (mattressVariantId && mattressQuantity && mattressTitle) {                                                                   
          formData.append(`items[${itemIndex}][id]`, mattressVariantId);
          formData.append(`items[${itemIndex}][quantity]`, mattressQuantity);                                                         
          itemIndex++;  // <-- FIXED: only increment when item was actually added
      }                                                                                                                               
  }


        //
        //  LM: Upsell - Headboard
        //
        // A removed headboard is hidden, not deleted, so skip hidden ones
        const headboardUpsell = document.querySelector('.selected-headboard-upsell:not(.hidden)');
        if (headboardUpsell) {
          const headboardVariantId = headboardUpsell.getAttribute('data-variant-id');
          const headboardQuantity = headboardUpsell.getAttribute('data-variant-quantity');
          const headboardTitle = document.querySelector('.product__block--product_title h1').textContent;
          const headboardImage = headboardUpsell.getAttribute('data-variant-image');
          const selectedColour = (
            document.querySelector('.product-colour-option-wrapper .selected-option')?.textContent || ''
          ).trim();

          // Properties only go with an id: an items[n] row without one makes
          // Shopify reject the whole add
          if (headboardVariantId && headboardQuantity && headboardTitle) {
            formData.append(`items[${itemIndex}][id]`, headboardVariantId);
            formData.append(`items[${itemIndex}][quantity]`, headboardQuantity);
            if (headboardImage) {
              formData.append(`items[${itemIndex}][properties][__custom_image]`, headboardImage);
            }
            if (selectedColour) {
              formData.append(`items[${itemIndex}][properties][Fabric Colour]`, selectedColour);
            }
            itemIndex++;                                                                                                            
          }                                                    
        }

        //
        // Optional Extras (Assembly / Disposal) — selection bundles with parent ATC
        //
        const parentQty =
          formData.get('quantity') ||
          form.querySelector('[name="quantity"]')?.value ||
          '1';
        const selectedExtras = document.querySelectorAll(
          '[data-optional-extra-checkbox]:checked'
        );

        const parentVariantId =
          formData.get('id') || form.querySelector('[name="id"]')?.value || '';

        if (selectedExtras.length > 0 && parentVariantId) {
          const parentTitleEl = document.querySelector(
            '.product__block--product_title h1'
          );
          const parentTitle = parentTitleEl
            ? parentTitleEl.textContent.trim()
            : '';

          selectedExtras.forEach((checkbox) => {
            const variantId = checkbox.dataset.variantId;
            const addonType = checkbox.dataset.addonType;
            if (!variantId || !addonType) return;

            formData.append(`items[${itemIndex}][id]`, variantId);
            formData.append(`items[${itemIndex}][quantity]`, parentQty);
            formData.append(
              `items[${itemIndex}][properties][_cb_parent_variant_id]`,
              parentVariantId
            );
            formData.append(
              `items[${itemIndex}][properties][_cb_addon_type]`,
              addonType
            );
            if (parentTitle) {
              formData.append(
                `items[${itemIndex}][properties][_For]`,
                parentTitle
              );
            }
            itemIndex += 1;
          });
        }
      }  
       
        setTimeout(() => { 
        if (formbutton.classList.contains('btn-cart-upsell')) {
          const openUpsellClose = document.querySelector('.cart-upsell-popup:popover-open .cart-upsell-popup-overlay');
          const savingsClose = document.querySelectorAll('.savings-wrapper details[open] summary');

          if (openUpsellClose) {
            openUpsellClose.click();
          }
          savingsClose.forEach(close => close.click());
        }
      }, 1000);

      setTimeout(() => {
        if (formbutton.classList.contains('btn-cart-edit')) {
          const cartEditClose = document.querySelector('.cart-edit-popup:popover-open .cart-edit-popup-overlay');
          const cartEditKey = formbutton.getAttribute('data-key');

          if (cartEditClose) {
            cartEditClose.click();
          }

          if (cartEditKey) {
            const cartItem = document.querySelector('.cart-item[data-cart-key-id="' + cartEditKey + '"]');
            if (cartItem) {
              const removeBtn = cartItem.querySelector('.cart-item-remove');
              if (removeBtn) {
                removeBtn.click();
              }
            }
          }
        }
      }, 1000);

      // Bundled section rendering: ask Shopify to render the cart drawer and
      // header in the same request as the add, so the drawer can open from a
      // single round-trip instead of chaining a homepage fetch, cart?view=ajax
      // and cart.js. Section IDs are read from the DOM so this keeps working if
      // the cart is redesigned or the section IDs change.
      const sectionsToRender = this.getSectionsToRender();
      const useSectionRendering = sectionsToRender.length > 0;

      if (useSectionRendering) {
        formData.append('sections', sectionsToRender.join(','));
        formData.append('sections_url', window.location.pathname);
      }

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        body: formData
      })
        .then((response) => {
          return response.json().then((data) => ({
            ok: response.ok,
            data: data,
          }));
        })
        .then(async ({ ok, data }) => {
          if (!ok || data.status === 422) {
            this.handleAddToCartAnimation('error', event, formbutton);
            console.error('Error:', data);
            return;
          }

          // Open immediately when add-to-cart succeeds — not tied to ATC animation.
          this.openSlideCart();

          document.querySelectorAll('[data-cart-empty]').forEach(cartEmpty => cartEmpty.remove());

          if (useSectionRendering && data.sections && this.renderFromSections(data.sections)) {
            return;
          }

          await this.refreshCart(null);
          this.fetchCartContents();
        })
        .catch((error) => {
          console.error('Error:', error);
          this.handleAddToCartAnimation('error', event, formbutton);
        })
        .finally(() => {
          delete form.dataset.cartAdding;
        });
    }

    /**
     * Saves an Edit / Overview change that keeps the variant (a new fabric,
     * say) with one cart/change.js on the existing line, merging its
     * properties. The old add-then-remove swap dropped the line's Protection
     * (its cover belonged to the removed line) and, on a slow connection,
     * could remove before the add landed. A different variant still swaps.
     * @param {HTMLFormElement} form
     * @param {FormData} formData
     * @param {HTMLElement} formbutton
     * @returns {boolean} True when handled here
     */
    editLineInPlace(form, formData, formbutton) {
      const oldKey = formbutton.getAttribute('data-key');
      const variantId = String(formData.get('id') || '');
      const row = oldKey && document.querySelector(`.cart-item[data-cart-key-id="${CSS.escape(oldKey)}"]`);
      if (!row || !variantId || row.getAttribute('data-variant-id') !== variantId) return false;

      const changes = {};
      for (const [name, value] of formData.entries()) {
        const match = /^properties\[(.+)\]$/.exec(name);
        if (match && typeof value === 'string') changes[match[1]] = value;
      }

      document.querySelector('.cart-edit-popup:popover-open .cart-edit-popup-overlay')?.click();
      if (this.isCartPage()) this._pageNeedsRepaint = true;

      this.queueCartWrite((cart) => {
        const line = this.findRowLine(cart, oldKey, variantId);
        if (!line) return null;
        const properties = Object.assign({}, line.properties || {}, changes);
        return this.postCart('cart/change.js', {
          id: line.key,
          quantity: line.quantity,
          properties,
        });
      }, undefined, { block: false });

      delete form.dataset.cartAdding;
      return true;
    }

    initializeCartEdit() {
      if (typeof window.initializeServiceBlockFunctionality === 'function') {
        window.initializeServiceBlockFunctionality();
      }
    }
  }

  window.__comfybedssCart = new Cart();
  return window.__comfybedssCart;
}

cartFunction();

class ProductCard extends HTMLElement {
  constructor() {
    super();

    this.actions = this.querySelectorAll('*:is(input, select, button:not([type="submit"]), textarea, .card-action)');

    this.actions.forEach(action => {
      action.addEventListener('click', (e) => {
        e.preventDefault();
      });
    });
  }
}

customElements.define('product-card', ProductCard);

// Cookie consent overlay management
function manageCookieConsentOverlay() {
  const consentContainer = document.querySelector('.cky-consent-container');
  const overlay = document.querySelector('.cky-overlay');

  if (consentContainer && overlay) {
    // Check if consent container does NOT have the 'cky-hide' class
    if (!consentContainer.classList.contains('cky-hide')) {
      // Remove 'cky-hide' class from overlay
      overlay.classList.remove('cky-hide');
    }
  }
}

// Wait for cookie consent elements to be dynamically loaded
function waitForCookieConsentElements() {
  let attempts = 0;
  const maxAttempts = 50; // Stop after 5 seconds (50 * 100ms)

  const checkForElements = () => {
    const consentContainer = document.querySelector('.cky-consent-container');
    const overlay = document.querySelector('.cky-overlay');

    if (consentContainer && overlay) {
      manageCookieConsentOverlay();

      // Set up a MutationObserver to watch for class changes
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            manageCookieConsentOverlay();
          }
        });
      });

      // Observe changes to the consent container's class attribute
      observer.observe(consentContainer, {
        attributes: true,
        attributeFilter: ['class']
      });

      return; // Stop checking once elements are found
    }

    attempts++;
    if (attempts < maxAttempts) {
      // If elements not found, check again in 100ms
      setTimeout(checkForElements, 100);
    }
  };

  checkForElements();
}

document.addEventListener("DOMContentLoaded", function () {

  // Header wrapper height property

  const headerWrapper = document.querySelector('.header-group-wrapper');
  if (headerWrapper && headerWrapper.offsetHeight > 0) {
    document.body.style.setProperty('--header-group-height', headerWrapper.offsetHeight + 'px');
  }

  var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));

  if ("IntersectionObserver" in window) {
    var lazyVideoObserver = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (video) {
        if (video.isIntersecting) {
          for (var source in video.target.children) {
            var videoSource = video.target.children[source];
            if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
              videoSource.src = videoSource.dataset.src;
            }
          }

          video.target.load();
          video.target.classList.remove("lazy");
          lazyVideoObserver.unobserve(video.target);
        }
      });
    });

    lazyVideos.forEach(function (lazyVideo) {
      lazyVideoObserver.observe(lazyVideo);
    });
  }

  // Initialize cookie consent overlay management
  waitForCookieConsentElements();

  // Add .is-sticky class to announcement bar when it becomes sticky
  function handleAnnouncementBarSticky() {
    const announcementBars = document.querySelectorAll('.announcement-bar');
    announcementBars.forEach(bar => {
      const section = bar.closest('.shopify-section');
      if (section && !document.body.classList.contains('template-product')) {
        const rect = section.getBoundingClientRect();
        const isSticky = rect.top <= 0 && window.getComputedStyle(section).position === 'sticky';
        requestAnimationFrame(() => {
          if (isSticky) {
            bar.classList.add('is-sticky');
          } else {
            bar.classList.remove('is-sticky');
          }
        });
      }
    });
  }

  // Check on scroll and resize
  let ticking = false;
  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(() => {
        handleAnnouncementBarSticky();
        ticking = false;
      });
      ticking = true;
    }
  }
  
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  requestAnimationFrame(() => {
    handleAnnouncementBarSticky(); // Initial check
  });

  // Add .btn__content wrapper to button children when loading state is added
  function wrapButtonContent() {
    document.querySelectorAll('.btn.loading-spinner').forEach(btn => {
      // Check if content is already wrapped
      if (btn.querySelector('.btn__content')) return;
      
      // Wrap all direct children in .btn__content
      const children = Array.from(btn.childNodes);
      if (children.length > 0) {
        const wrapper = document.createElement('span');
        wrapper.className = 'btn__content';
        // Move all nodes (elements and text) into wrapper
        // Use a document fragment to avoid reflow issues
        const fragment = document.createDocumentFragment();
        children.forEach(child => {
          fragment.appendChild(child);
        });
        wrapper.appendChild(fragment);
        btn.appendChild(wrapper);
      }
    });
  }

  // Watch for buttons getting loading-spinner class (removed one-time setup, MutationObserver handles dynamic content)
  if ('MutationObserver' in window) {
    const buttonObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const target = mutation.target;
          if (target.classList && target.classList.contains('btn') && target.classList.contains('loading-spinner')) {
            wrapButtonContent();
          }
        }
        if (mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1 && node.classList && node.classList.contains('btn') && node.classList.contains('loading-spinner')) {
              wrapButtonContent();
            }
          });
        }
      });
    });
    
    buttonObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ['class'],
      childList: true,
      subtree: true
    });
  }

});

